import * as yup from 'yup';

export const preference = yup.string().required('Påkrævet');
